// src/services/users.ts
import { apiJson } from './http';

export type UserDTO = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: 'ADMIN' | 'PJM' | 'USER' | 'CUSTOMER' | 'FINANCE' | 'VIDEOMAKER';
  isActive: boolean;
  lastLogin?: string | null;
  companyId?: number | null;
  companyName?: string | null;
  customerId?: number | null;
  customerName?: string | null;
  color?: string | null;
};

export type CreateUserPayload = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: UserDTO['role'];
  active?: boolean;
  /** One-shot link: se valorizzato, il backend collegherà subito l'utente al customer */
  customerId?: number;
  color?: string | null;
};

export type UpdateUserPayload = Partial<{
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: UserDTO['role'];
  active: boolean;
  color: string | null;
}>;

export async function getTeam(): Promise<UserDTO[]> {
  return apiJson<UserDTO[]>('/p/users/team');
}

export async function getMe(): Promise<UserDTO> {
  return apiJson<UserDTO>('/p/users/me');
}

export async function createUser(payload: CreateUserPayload): Promise<UserDTO> {
  return apiJson<UserDTO>('/p/users/createuser', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateUser(id: number, payload: UpdateUserPayload): Promise<UserDTO> {
  return apiJson<UserDTO>(`/p/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

/** Verifica univocità email lato backend */
export async function checkEmailUnique(
  email: string
): Promise<{ email: string; available: boolean }> {
  const qs = new URLSearchParams({ email }).toString();
  return apiJson<{ email: string; available: boolean }>(`/p/users/check-email?${qs}`);
}
